<div class="max-w-sm p-4 bg-white rounded-lg shadow-md">
  <div class="flex items-center space-x-4">
    <div *ngIf="iconName" [ngClass]="iconContainerClasses">
      <app-system-icon [iconName]="iconName" [iconSize]="iconSize" [iconType]="iconType"></app-system-icon>
    </div>
    <div>
      <p [ngClass]="[titleSize, titleFont, 'text-gray-900']">{{ title }}</p>
      <p [ngClass]="[subtitleSize, subtitleFont, 'text-gray-500']">{{ subtitle }}</p>
    </div>
  </div>
</div>
